<template>
    <div class="account-page">
        <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                    <layout-header />
			<!-- /Header -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="container-fluid">
					
					<div class="row">
						<div class="col-md-8 offset-md-2">
							
							<!-- Account Content -->
							<div class="account-content">
								<div class="row align-items-center justify-content-center">
									<div class="col-md-7 col-lg-6 login-left">
										<img src="@/assets/img/login-banner.png" class="img-fluid" alt="Login Banner">	
									</div>
									<div class="col-md-12 col-lg-6 login-right">
										<div class="login-header">
											<h3>Lupa Password?</h3>
											<p class="small text-muted">Silahkan Masukkan email yang sudah terdaftar untuk melakukan reset password</p>
										</div>
										
										<!-- Forgot Password Form -->
										
										<div class="alert alert-danger" v-if="errors">
											{{ errors }}
										</div>
										<div class="alert alert-warning" v-if="msg">
											{{ msg }}
										</div>
										<form @submit.prevent="forgotPassword">
											<div class="form-group form-focus">
												<input type="email" class="form-control floating" v-model="form.email" >
												<label class="focus-label">Email</label>
											</div>
											<div class="text-right">
												<router-link class="forgot-link" to="/login">Sudah ingat passwordmu?</router-link>
											</div>
											<button class="btn btn-primary btn-block btn-lg login-btn" type="submit">Kirim Link Reset Password</button>
										</form>
										<!-- /Forgot Password Form -->
										
									</div>
								</div>
							</div>
							<!-- /Account Content -->
							
						</div>
					</div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->
    </div>
</template>

<script>  

import Util from '../../../assets/utils/utils'
import {mapGetters} from 'vuex'

import axios from 'axios';

  export default {  
    data(){
      return {
        form: {
          email: '',
          password: '',
        },
        errors: null,
        msg: null
      }
    },
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
        currentPath() {
            return this.$route.name
        }
    },
    created:function () {
      if(this.user){
        if(this.user.hak_akses == '1')
          this.$router.push({name: 'siswa-profile-settings'})
        else if(this.user.hak_akses == '2')
          this.$router.push({name: 'instructor-profile-settings'})
        else if(this.user.hak_akses == '3')
          this.$router.push({name: 'admin-profile-settings'})
      }
        
    },
    methods: {
		
        forgotPassword: function () {
            axios.post('forgotPassword', {
                    email: this.form.email
                })
                .then(res => {
                  	this.form.email = '';
					this.msg = res.data.message;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
        			this.errors = err.data.message;
                })
        },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Pages/ForgotPassword/index.vue